import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Stack,
  StackDirection,
  Text,
  useTheme,
  VStack,
} from '@chakra-ui/react'
import {ReactNode} from 'react'

interface Props {
  label?: string
  error: boolean
  errorMessage?: string
  required?: boolean
  direction: StackDirection
  children: ReactNode
}

const FormControlledInput = ({
  label,
  error,
  errorMessage,
  children,
  required = false,
  direction,
}: Props) => {
  const theme = useTheme()
  return (
    <FormControl isInvalid={error} isRequired={required}>
      <VStack w='full' align='start'>
        <Stack
          direction={direction}
          w='full'
          align='start'
          spacing={1}
          placeItems={direction === 'column' ? 'start' : 'center'}>
          {label && (
            <FormLabel
              margin={0}
              w='20rem'
              variant='big'
              color={theme.colors.text.basic}
              display='flex'
              requiredIndicator={
                <Text pl={1} variant='big' color={theme.colors.text.grey}>
                  *
                </Text>
              }>
              {label}
            </FormLabel>
          )}
          {children}
        </Stack>

        <FormErrorMessage w='full'>
          <Stack direction={direction} w='full' align='start' spacing={1} h='full'>
            <Box w='20rem' display='flex' />
            <Text color={theme.colors.brand.error} w='full'>
              {error && errorMessage}
            </Text>
          </Stack>
        </FormErrorMessage>
      </VStack>
    </FormControl>
  )
}

export default FormControlledInput
